<template>
  <div class="edit-platform">
    <!--标题-->
    <!--    <div class="breadcrumb" style="background: #fff">{{ $route.params.title }}</div>-->
    <div class="breadcrumb" style="background: #fff">编辑VIP信息</div>
    <div class="third-title"><span>基础信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" ref="ruleForm" :rules="rules" label-width="170px" class="demo-ruleForm">
        <el-form-item label="平台号:">
          <span>{{ basicInfo.code }}</span>
        </el-form-item>
        <el-form-item label="平台名称:"> {{ basicInfo.name }} </el-form-item>
        <el-form-item label="公司名称:"> {{ basicInfo.companyName }} </el-form-item>
        <el-form-item label="开票资质:">
          <el-switch v-model="basicInfo.invoice" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0">
          </el-switch>
        </el-form-item>
        <el-form-item label="收款账号:" prop="collectionAccount" v-if="basicInfo.invoice">
          <el-input v-model="basicInfo.collectionAccount"></el-input>
        </el-form-item>
        <el-form-item label="户名:" prop="accountName" v-if="basicInfo.invoice">
          <el-input v-model="basicInfo.accountName"></el-input>
        </el-form-item>
        <el-form-item label="开户行:" prop="bank" v-if="basicInfo.invoice">
          <el-input v-model="basicInfo.bank"></el-input>
        </el-form-item>
        <el-form-item label="营业执照:" v-if="basicInfo.invoice">
          <el-upload action="#" :show-file-list='false' :http-request="(e) => uploadImg(e, 'licenseUrl')">
            <el-button type="primary" round>上传</el-button>
          </el-upload>
          <el-image v-show="basicInfo.licenseUrl" style="max-width:200px;margin-top: 10px;" class='yingye' :src="basicInfo.licenseUrl" fit="cover" :preview-src-list="[basicInfo.licenseUrl]">
          </el-image>
        </el-form-item>
        <el-form-item label="支付方式:">
          <el-select v-model="basicInfo.paymentType" placeholder="请选择" class="customer-select">
            <!--            <el-option label="码支付" value="CODE"></el-option>-->
            <el-option label="余额支付" value="BALANCE"></el-option>
            <el-option label="在线支付" value="ONLINE"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="微信二维码:">
          <el-image style="max-width:200px" v-if="basicInfo.qrCode !== undefined && basicInfo.qrCode !== ''" class="yingye" :src="basicInfo.qrCode" :preview-src-list="[basicInfo.qrCode]"></el-image>
        </el-form-item>
        <el-form-item label="是否为淘宝平台:">
          <el-switch v-model="basicInfo.tbOrder" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="是否支持生成核销码:">
          <el-switch v-model="basicInfo.supportVerificationCode" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="是否为抖音平台:">
          <el-switch v-model="basicInfo.dyOrder" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="是否为获客平台:">
          <el-switch v-model="basicInfo.acquisition" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="是否设置代理价格:">
          <el-switch v-model="basicInfo.agentPrice" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="是否开通云底片:">
          <el-switch v-model="basicInfo.cloudFilm" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="是否开通预约服务:">
          <el-switch v-model="basicInfo.appointment" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="产品分享给客户:">
          <el-switch v-model="basicInfo.isProductShare" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="是否支持导出物流编码:">
          <el-switch v-model="basicInfo.kttExpressExport" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="是否支持APP:">
          <el-switch v-model="basicInfo.supportApp" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
          <span style="margin-left: 10px;color:red;">注：仅自营店铺可打开此开关</span>
        </el-form-item>
        <el-form-item label="是否为渠道客户:">
          <el-switch v-model="basicInfo.channelCustomer" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" @change="customerChange"></el-switch>
          <span style="margin-left: 10px;color:red;font-size: 12px;">注:1.余额支付并开启，需要配置第三方的小程序名称，ID，密钥和图标，如鼎星；2.在线支付并开启，需要配置第三方小程序名称，ID，密
            钥和图标，商户ID，密钥路径，证书序列号，APPlv3密钥。C端客户支付到B端微信账户，后台自动扣B端平台余额的金额。如：冉逸</span>
        </el-form-item>
        <el-form-item label="是否为余额自动支付:">
          <!-- :disabled="basicInfo.channelCustomer === 1" -->
          <el-switch v-model="basicInfo.automaticPayment" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
          <span style="margin-left: 10px;color:red;">注:开启后产品可生成余额支付码和余额支付电子卡券，C端客户使用码券提交的订单平台余额自动支付</span>
        </el-form-item>
        <el-form-item label="是否自定义小程序首页:">
          <el-switch v-model="basicInfo.diyHomepage" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
          <span style="margin-left: 10px;color:red;">注：开启后平台可自行个性化设置小程序首页界面模块的图片和顺序</span>
        </el-form-item>
        <el-form-item label="小程序名称:" prop="appletName" v-if="basicInfo.channelCustomer">
          <el-input v-model="basicInfo.appletName"></el-input>
        </el-form-item>
        <el-form-item label="小程序ID:" prop="appId" v-if="basicInfo.channelCustomer">
          <el-input v-model="basicInfo.appId"></el-input>
        </el-form-item>
        <el-form-item label="小程序密钥:" prop="wxsecret" v-if="basicInfo.channelCustomer">
          <el-input v-model="basicInfo.wxsecret"></el-input>
        </el-form-item>
        <el-form-item label="小程序图标:" v-if="basicInfo.channelCustomer">
          <el-upload action="#" :show-file-list='false' :http-request="(e) => uploadImg(e, 'icon')">
            <el-button type="primary" round>上传</el-button>
          </el-upload>
          <el-image v-show="basicInfo.icon" style="max-width:200px;margin-top: 10px;" class='yingye' :src="basicInfo.icon" fit="cover" :preview-src-list="[basicInfo.icon]">
          </el-image>
        </el-form-item>
        <el-form-item label="商户Id:" prop="merchantId" v-if="basicInfo.channelCustomer && basicInfo.paymentType == 'ONLINE'">
          <el-input v-model="basicInfo.merchantId" placeholder="请输入商户Id"></el-input>
        </el-form-item>
        <el-form-item label="私钥路径:" prop="privateKeyPath" v-if="basicInfo.channelCustomer && basicInfo.paymentType == 'ONLINE'">
          <el-input v-model="basicInfo.privateKeyPath" placeholder="请输入私钥路径"></el-input>
        </el-form-item>
        <el-form-item label="证书序列号:" prop="merchantSerialNumber" v-if="basicInfo.channelCustomer && basicInfo.paymentType == 'ONLINE'">
          <el-input v-model="basicInfo.merchantSerialNumber" placeholder="请输入证书序列号"></el-input>
        </el-form-item>
        <el-form-item label="APIv3秘钥:" prop="apiV3Key" v-if="basicInfo.channelCustomer && basicInfo.paymentType == 'ONLINE'">
          <el-input v-model="basicInfo.apiV3Key" placeholder="请输入APIv3秘钥" maxlength="32"></el-input>
        </el-form-item>
        <el-form-item label="是否使用公钥验签:" prop="wechatPublicPay" v-if="basicInfo.channelCustomer && basicInfo.paymentType == 'ONLINE'">
          <el-switch v-model="basicInfo.wechatPublicPay" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="公钥路径:" prop="publicKeyPath" v-if="basicInfo.channelCustomer && basicInfo.paymentType == 'ONLINE' && basicInfo.wechatPublicPay">
          <el-input v-model="basicInfo.publicKeyPath" placeholder="请输入公钥路径"></el-input>
        </el-form-item>
        <el-form-item label="公钥Id:" prop="publicKeyId" v-if="basicInfo.channelCustomer && basicInfo.paymentType == 'ONLINE' && basicInfo.wechatPublicPay">
          <el-input v-model="basicInfo.publicKeyId" placeholder="请输入公钥Id"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="$router.go(-1)">返回</el-button>
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="confirmSave" v-preventReClick>保存</el-button>
    </div>
    <el-dialog :close-on-click-modal="false" title="确认提示" :visible.sync="saveDialog" width="30%">
      <span>是否确认修改？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="saveDialog = false">取 消</el-button>
        <el-button type="primary" @click="save" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
    <CombinedDialog ref="dialogRef"></CombinedDialog>
  </div>
</template>
<script>
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import { vipStoreQueryByStoreId, vipStoreUpdateStore } from '@/api/crm'
import uploadWebImg from '@/utils/uploadWebImg'
export default {
  name: 'vipEditPlatform',
  components: {
    CombinedDialog
  },
  data () {
    return {
      saveMsg: '',
      saveDialog: false,
      type: '',
      btnContent: '',
      isRepeat: true,
      isCheckedRepeat: true,
      basicInfo: {
        diyHomepage: 0,
        address: {
          // fullAddress: ''
        },
        storeTypeBean: {
          id: null
        }
      },
      flag: false,
      rules: {
        collectionAccount: [
          { required: true, message: '请输入收款账号', trigger: 'blur' }
        ],
        accountName: [
          { required: true, message: '请输入户名', trigger: 'blur' }
        ],
        bank: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        appletName: [
          { required: true, message: '请输入小程序名称', trigger: 'blur' }
        ],
        appId: [
          { required: true, message: '请输入小程序ID', trigger: 'blur' }
        ],
        wxsecret: [
          { required: true, message: '请输入小程序密钥', trigger: 'blur' }
        ],
        apiV3Key: [
          { max: 32, message: 'APIv3密钥长度不能超过32位', trigger: 'blur' }
        ],
        publicKeyPath: [
          { required: true, message: '请输入公钥路径', trigger: 'blur' }
        ],
        publicKeyId: [
          { required: true, message: '请输入公钥Id', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    if (this.$checkAwsSdk('product')) {
      this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    }
    let id = this.$route.query.id
    vipStoreQueryByStoreId(id).then((res) => {
      if (res.data.success) {
        let obj = {}
        obj = res.data.data
        obj.sendFlag = obj.sendFlag === undefined ? '1' : obj.sendFlag
        if (!obj.address) {
          obj.address = {}
        }
        if (res.data.data.storeTypeBean === undefined) {
          obj.storeTypeBean = {
            id: ''
          }
        }
        if (obj.wxConfigList.length > 0) {
          this.basicInfo = {
            ...obj,
            appletName: obj.wxConfigList[0].appletName,
            appId: obj.wxConfigList[0].appId,
            wxsecret: obj.wxConfigList[0].wxsecret,
            icon: obj.wxConfigList[0].icon,
            merchantId: obj.wxConfigList[0].merchantId,
            privateKeyPath: obj.wxConfigList[0].privateKeyPath,
            merchantSerialNumber: obj.wxConfigList[0].merchantSerialNumber,
            apiV3Key: obj.wxConfigList[0].apiV3Key,
            publicKeyPath: obj.wxConfigList[0].publicKeyPath,
            publicKeyId: obj.wxConfigList[0].publicKeyId,
            wechatPublicPay: Number(obj.wxConfigList[0].wechatPublicPay)
          }
        } else {
          this.basicInfo = obj
        }
      } else {

      }
    })
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  methods: {
    customerChange (value) {
      console.log(value)
      if (value === 1) {
        this.$set(this.basicInfo, 'appletName', '')
        this.$set(this.basicInfo, 'appId', '')
        this.$set(this.basicInfo, 'wxsecret', '')
        this.$set(this.basicInfo, 'icon', '')
        // this.basicInfo.automaticPayment = 1
      }
    },
    confirmSave () {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          return
        }
        if (this.basicInfo.invoice && !this.basicInfo.licenseUrl) {
          this.$message.error('请上传营业执照')
          return
        }
        if (this.basicInfo.channelCustomer && !this.basicInfo.icon) {
          this.$message.error('请上传小程序图标')
          return
        }
        this.saveDialog = true
      })
    },
    save () {
      let updateVipStoreVo = {
        diyHomepage: this.basicInfo.diyHomepage,
        accountName: this.basicInfo.accountName,
        tbOrder: this.basicInfo.tbOrder,
        supportVerificationCode: this.basicInfo.supportVerificationCode,
        dyOrder: this.basicInfo.dyOrder,
        acquisition: this.basicInfo.acquisition,
        agentPrice: this.basicInfo.agentPrice,
        cloudFilm: this.basicInfo.cloudFilm,
        appointment: this.basicInfo.appointment,
        isProductShare: this.basicInfo.isProductShare,
        kttExpressExport: this.basicInfo.kttExpressExport,
        bank: this.basicInfo.bank,
        collectionAccount: this.basicInfo.collectionAccount,
        companyName: this.basicInfo.companyName,
        id: this.basicInfo.id,
        invoice: this.basicInfo.invoice,
        licenseUrl: this.basicInfo.licenseUrl,
        paymentType: this.basicInfo.paymentType,
        qrCode: this.basicInfo.qrCode,
        channelCustomer: this.basicInfo.channelCustomer,
        wechatPublicPay: this.basicInfo.wechatPublicPay,
        supportApp: this.basicInfo.supportApp,
        automaticPayment: this.basicInfo.automaticPayment,
        wxConfigList: [{
          icon: this.basicInfo.icon,
          appletName: this.basicInfo.appletName,
          appId: this.basicInfo.appId,
          wxsecret: this.basicInfo.wxsecret,
          id: this.basicInfo.wxConfigList.length > 0 ? this.basicInfo.wxConfigList[0].id : null,
          merchantId: this.basicInfo.merchantId,
          privateKeyPath: this.basicInfo.privateKeyPath,
          merchantSerialNumber: this.basicInfo.merchantSerialNumber,
          apiV3Key: this.basicInfo.apiV3Key,
          publicKeyPath: this.basicInfo.publicKeyPath,
          publicKeyId: this.basicInfo.publicKeyId
        }]
      }
      vipStoreUpdateStore(updateVipStoreVo).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.$router.go(-1)
        }
      })
    },
    uploadImg (e, key) {
      console.log(e, key)
      let file = e.file
      if (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      uploadWebImg(file, this.$store.state.awsSdk.product.s3, [], (e) => {
      }).then(res => {
        if (res === 'error') {
          this.$message.error('服务器问题，请刷新页面重试或联系管理员')
          return
        }
        console.log(res, '11111')
        if (key === 'icon') {
          this.basicInfo.icon = res
        } else {
          this.basicInfo.licenseUrl = res
        }
        this.$forceUpdate()
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "index";

@deep: ~">>>";
</style>
